import { EmptyState } from "components/EmptyState/EmptyState";
import { FormSection } from "components/FormControls/FormSection";
import { OLMenuButton } from "components/FormControls/OLMenuButton";
import { ReactComponent as CodeSquare02Icon } from "components/Icons/code-square-02.svg";
import { FieldArray } from "formik";
import { useMessage } from "hooks/intl";
import { TransactionItem } from "types/campaigns";
import { TransactionItemFilter } from "./TransactionItemFilter/TransactionItemFilter";
import { itemFilters } from "./helpers";

interface Props {
  errors: any;
}

const maxTransactionItemsFiltersCount = 2;

export const CampaignTransactionItemFilters = ({ errors }: Props) => {
  const { message } = useMessage();

  return (
    <FormSection title={message({ id: "transactionItemFilters" })}>
      <FieldArray
        name="transactionItemsFilters"
        render={({ push, form: { values, setFieldValue } }) => {
          const {
            transactionItemsFilters,
          }: { transactionItemsFilters: TransactionItem[] } = values;
          const areFiltersAdded =
            transactionItemsFilters && transactionItemsFilters.length > 0;

          return areFiltersAdded ? (
            <>
              {transactionItemsFilters.map((item, index) => {
                const currentError =
                  errors.transactionItemsFilters &&
                  (errors.transactionItemsFilters as [])[index];

                return (
                  <TransactionItemFilter
                    key={index}
                    transactionItemFilterIndex={index}
                    name={item.name}
                    setFieldValue={setFieldValue}
                    error={currentError}
                  />
                );
              })}
              <OLMenuButton
                buttonVariant="contained"
                data-test-id="add-new-transaction-filter"
                items={itemFilters.map((item) => {
                  return {
                    label: message({ id: item.label }),
                    onClick: () => {
                      push({
                        code: `scenario_${transactionItemsFilters.length + 1}`,
                        name: `Scenario ${transactionItemsFilters.length + 1}`,
                        filters: [
                          {
                            value: {
                              field: item.id,
                            },
                            type: item.type,
                            label: item.label,
                            isSaved: false,
                            isEditMode: false,
                          },
                        ],
                      });
                    },
                  };
                })}
                hideSearch
                submit={message({
                  id: "addNewTransactionFilter",
                })}
                disabled={
                  transactionItemsFilters.length >=
                  maxTransactionItemsFiltersCount
                }
              />
            </>
          ) : (
            <EmptyState
              icon={<CodeSquare02Icon />}
              title={message({ id: "addFirstTransactionItemFilters" })}
              description={message({
                id: "campaignsTransactionFiltersDescription",
              })}
              button={
                <OLMenuButton
                  buttonVariant="contained"
                  data-test-id="new-filter"
                  items={itemFilters.map((item, index) => {
                    return {
                      label: message({ id: item.label }),
                      onClick: () => {
                        push({
                          code: `scenario_1`,
                          name: `Scenario 1`,
                          filters: [
                            {
                              value: {
                                field: item.id,
                              },
                              label: item.label,
                              type: item.type,
                              isSaved: false,
                              isEditMode: false,
                            },
                          ],
                        });
                      },
                    };
                  })}
                  hideSearch
                  submit={message({
                    id: "newFilter",
                  })}
                />
              }
            />
          );
        }}
      />
    </FormSection>
  );
};
